module.exports = __webpack_public_path__ + "static/Unisel5-9ba9729016ba2d095854e0c3a22f2fed.jpg";